import React from 'react';
import styled from 'styled-components';

const BorderCut = styled.div`
    overflow: hidden;
    width: 100%;
    border-radius: 16px;
`;

export const Control = (props: any) => {
    const { children, cx, className, isDisabled, isFocused, innerRef, innerProps, menuIsOpen, selectProps } = props;

    return (
        <BorderCut
            ref={innerRef}
            data-cy={selectProps.cy}
        >
            <div
                ref={innerRef}
                className={cx(
                    {
                        control: true,
                        'control--is-disabled': isDisabled,
                        'control--is-focused': isFocused,
                        'control--menu-is-open': menuIsOpen,
                    },
                    className,
                )}
                {...innerProps}
            >
                {children}
            </div>
        </BorderCut>
    );
};
